/**
 * The five platform spaces and their accent hues.
 *
 * A space is indicated on the mark by ONE restrained feature: the color of
 * the dot (and, in the lockup, the current breadcrumb crumb). Everything
 * else stays ink-on-ground. The hues are proposals on the platform's
 * dark-charcoal / cream / warm-orange world — muted, editorial, tuned for
 * cream-ink-on-charcoal first; the operator will tune the exact values via
 * the `--brand-space-*` custom properties.
 */

export const SPACES = [
  "personal",
  "business",
  "family",
  "community",
  "public",
] as const;

export type Space = (typeof SPACES)[number];

/** Proposed accent per space (CSS default values; override via custom props). */
export const SPACE_ACCENTS: Record<Space, string> = {
  /** Warm ember — the platform's own warm orange, the default. */
  personal: "#DE8D51",
  /** Steel blue — composed, contractual. */
  business: "#8FA9C9",
  /** Soft rose — kinship warmth without candy. */
  family: "#C98A93",
  /** Sage — grown together. */
  community: "#9DB380",
  /** Celadon — open air, civic calm. */
  public: "#84B0A6",
};

export function isSpace(value: string | null): value is Space {
  return value !== null && (SPACES as readonly string[]).includes(value);
}
